import { City } from '@/types/city.type';

export const MAIN_CITIES_AC: City[] = [
  { city: 'Rio Branco', state_abbr: 'AC', slug: 'rio-branco-ac' },
  { city: 'Cruzeiro do Sul', state_abbr: 'AC', slug: 'cruzeiro-do-sul-ac' },
  { city: 'Sena Madureira', state_abbr: 'AC', slug: 'sena-madureira-ac' },
  { city: 'Tarauacá', state_abbr: 'AC', slug: 'tarauaca-ac' },
  { city: 'Feijó', state_abbr: 'AC', slug: 'feijo-ac' },
];

export const MAIN_CITIES_AL: City[] = [
  { city: 'Maceió', state_abbr: 'AL', slug: 'maceio-al' },
  { city: 'Arapiraca', state_abbr: 'AL', slug: 'arapiraca-al' },
  { city: 'Palmeira dos Índios', state_abbr: 'AL', slug: 'palmeira-dos-indios-al' },
  { city: 'Penedo', state_abbr: 'AL', slug: 'penedo-al' },
  { city: 'União dos Palmares', state_abbr: 'AL', slug: 'uniao-dos-palmares-al' },
];

export const MAIN_CITIES_AP: City[] = [
  { city: 'Macapá', state_abbr: 'AP', slug: 'macapa-ap' },
  { city: 'Santana', state_abbr: 'AP', slug: 'santana-ap' },
  { city: 'Laranjal do Jari', state_abbr: 'AP', slug: 'laranjal-do-jari-ap' },
  { city: 'Mazagão', state_abbr: 'AP', slug: 'mazagao-ap' },
  { city: 'Oiapoque', state_abbr: 'AP', slug: 'oiapoque-ap' },
];

export const MAIN_CITIES_AM: City[] = [
  { city: 'Manaus', state_abbr: 'AM', slug: 'manaus-am' },
  { city: 'Parintins', state_abbr: 'AM', slug: 'parintins-am' },
  { city: 'Itacoatiara', state_abbr: 'AM', slug: 'itacoatiara-am' },
  { city: 'Manacapuru', state_abbr: 'AM', slug: 'manacapuru-am' },
  { city: 'Coari', state_abbr: 'AM', slug: 'coari-am' },
];

export const MAIN_CITIES_BA: City[] = [
  { city: 'Salvador', state_abbr: 'BA', slug: 'salvador-ba' },
  { city: 'Feira de Santana', state_abbr: 'BA', slug: 'feira-de-santana-ba' },
  { city: 'Vitória da Conquista', state_abbr: 'BA', slug: 'vitoria-da-conquista-ba' },
  { city: 'Camaçari', state_abbr: 'BA', slug: 'camacari-ba' },
  { city: 'Itabuna', state_abbr: 'BA', slug: 'itabuna-ba' },
];

export const MAIN_CITIES_CE: City[] = [
  { city: 'Fortaleza', state_abbr: 'CE', slug: 'fortaleza-ce' },
  { city: 'Caucaia', state_abbr: 'CE', slug: 'caucaia-ce' },
  { city: 'Juazeiro do Norte', state_abbr: 'CE', slug: 'juazeiro-do-norte-ce' },
  { city: 'Maracanaú', state_abbr: 'CE', slug: 'maracanau-ce' },
  { city: 'Sobral', state_abbr: 'CE', slug: 'sobral-ce' },
];

export const MAIN_CITIES_DF: City[] = [
  { city: 'Brasília', state_abbr: 'DF', slug: 'brasilia-df' },
];

export const MAIN_CITIES_ES: City[] = [
  { city: 'Vitória', state_abbr: 'ES', slug: 'vitoria-es' },
  { city: 'Vila Velha', state_abbr: 'ES', slug: 'vila-velha-es' },
  { city: 'Serra', state_abbr: 'ES', slug: 'serra-es' },
  { city: 'Linhares', state_abbr: 'ES', slug: 'linhares-es' },
  { city: 'Cariacica', state_abbr: 'ES', slug: 'cariacica-es' },
];

export const MAIN_CITIES_GO: City[] = [
  { city: 'Goiânia', state_abbr: 'GO', slug: 'goiania-go' },
  { city: 'Aparecida de Goiânia', state_abbr: 'GO', slug: 'aparecida-de-goiania-go' },
  { city: 'Anápolis', state_abbr: 'GO', slug: 'anapolis-go' },
  { city: 'Rio Verde', state_abbr: 'GO', slug: 'rio-verde-go' },
  { city: 'Luziânia', state_abbr: 'GO', slug: 'luziania-go' },
];

export const MAIN_CITIES_MA: City[] = [
  { city: 'São Luís', state_abbr: 'MA', slug: 'sao-luis-ma' },
  { city: 'Imperatriz', state_abbr: 'MA', slug: 'imperatriz-ma' },
  { city: 'Timon', state_abbr: 'MA', slug: 'timon-ma' },
  { city: 'Caxias', state_abbr: 'MA', slug: 'caxias-ma' },
  { city: 'Codó', state_abbr: 'MA', slug: 'codo-ma' },
];

export const MAIN_CITIES_MT: City[] = [
  { city: 'Cuiabá', state_abbr: 'MT', slug: 'cuiaba-mt' },
  { city: 'Várzea Grande', state_abbr: 'MT', slug: 'varzea-grande-mt' },
  { city: 'Rondonópolis', state_abbr: 'MT', slug: 'rondonopolis-mt' },
  { city: 'Sinop', state_abbr: 'MT', slug: 'sinop-mt' },
  { city: 'Tangará da Serra', state_abbr: 'MT', slug: 'tangara-da-serra-mt' },
];

export const MAIN_CITIES_MS: City[] = [
  { city: 'Campo Grande', state_abbr: 'MS', slug: 'campo-grande-ms' },
  { city: 'Dourados', state_abbr: 'MS', slug: 'dourados-ms' },
  { city: 'Três Lagoas', state_abbr: 'MS', slug: 'tres-lagoas-ms' },
  { city: 'Corumbá', state_abbr: 'MS', slug: 'corumba-ms' },
  { city: 'Ponta Porã', state_abbr: 'MS', slug: 'ponta-pora-ms' },
];

export const MAIN_CITIES_MG: City[] = [
  { city: 'Belo Horizonte', state_abbr: 'MG', slug: 'belo-horizonte-mg' },
  { city: 'Uberlândia', state_abbr: 'MG', slug: 'uberlandia-mg' },
  { city: 'Contagem', state_abbr: 'MG', slug: 'contagem-mg' },
  { city: 'Juiz de Fora', state_abbr: 'MG', slug: 'juiz-de-fora-mg' },
  { city: 'Betim', state_abbr: 'MG', slug: 'betim-mg' },
];

export const MAIN_CITIES_PA: City[] = [
  { city: 'Belém', state_abbr: 'PA', slug: 'belem-pa' },
  { city: 'Ananindeua', state_abbr: 'PA', slug: 'ananindeua-pa' },
  { city: 'Santarém', state_abbr: 'PA', slug: 'santarem-pa' },
  { city: 'Castanhal', state_abbr: 'PA', slug: 'castanhal-pa' },
  { city: 'Marabá', state_abbr: 'PA', slug: 'maraba-pa' },
];

export const MAIN_CITIES_PB: City[] = [
  { city: 'João Pessoa', state_abbr: 'PB', slug: 'joao-pessoa-pb' },
  { city: 'Campina Grande', state_abbr: 'PB', slug: 'campina-grande-pb' },
  { city: 'Santa Rita', state_abbr: 'PB', slug: 'santa-rita-pb' },
  { city: 'Patos', state_abbr: 'PB', slug: 'patos-pb' },
  { city: 'Bayeux', state_abbr: 'PB', slug: 'bayeux-pb' },
];

export const MAIN_CITIES_PR: City[] = [
  { city: 'Curitiba', state_abbr: 'PR', slug: 'curitiba-pr' },
  { city: 'Londrina', state_abbr: 'PR', slug: 'londrina-pr' },
  { city: 'Maringá', state_abbr: 'PR', slug: 'maringa-pr' },
  { city: 'Ponta Grossa', state_abbr: 'PR', slug: 'ponta-grossa-pr' },
  { city: 'Cascavel', state_abbr: 'PR', slug: 'cascavel-pr' },
];

export const MAIN_CITIES_PE: City[] = [
  { city: 'Recife', state_abbr: 'PE', slug: 'recife-pe' },
  { city: 'Jaboatão dos Guararapes', state_abbr: 'PE', slug: 'jaboatao-dos-guararapes-pe' },
  { city: 'Olinda', state_abbr: 'PE', slug: 'olinda-pe' },
  { city: 'Caruaru', state_abbr: 'PE', slug: 'caruaru-pe' },
  { city: 'Petrolina', state_abbr: 'PE', slug: 'petrolina-pe' },
];

export const MAIN_CITIES_PI: City[] = [
  { city: 'Teresina', state_abbr: 'PI', slug: 'teresina-pi' },
  { city: 'Parnaíba', state_abbr: 'PI', slug: 'parnaiba-pi' },
  { city: 'Picos', state_abbr: 'PI', slug: 'picos-pi' },
  { city: 'Piripiri', state_abbr: 'PI', slug: 'piripiri-pi' },
  { city: 'Floriano', state_abbr: 'PI', slug: 'floriano-pi' },
];

export const MAIN_CITIES_RJ: City[] = [
  { city: 'Rio de Janeiro', state_abbr: 'RJ', slug: 'rio-de-janeiro-rj' },
  { city: 'São Gonçalo', state_abbr: 'RJ', slug: 'sao-goncalo-rj' },
  { city: 'Duque de Caxias', state_abbr: 'RJ', slug: 'duque-de-caxias-rj' },
  { city: 'Nova Iguaçu', state_abbr: 'RJ', slug: 'nova-iguacu-rj' },
  { city: 'Niterói', state_abbr: 'RJ', slug: 'niteroi-rj' },
];

export const MAIN_CITIES_RN: City[] = [
  { city: 'Natal', state_abbr: 'RN', slug: 'natal-rn' },
  { city: 'Mossoró', state_abbr: 'RN', slug: 'mossoro-rn' },
  { city: 'Parnamirim', state_abbr: 'RN', slug: 'parnamirim-rn' },
  { city: 'Ceará-Mirim', state_abbr: 'RN', slug: 'ceara-mirim-rn' },
  { city: 'Caicó', state_abbr: 'RN', slug: 'caico-rn' },
];

export const MAIN_CITIES_RS: City[] = [
  { city: 'Porto Alegre', state_abbr: 'RS', slug: 'porto-alegre-rs' },
  { city: 'Caxias do Sul', state_abbr: 'RS', slug: 'caxias-do-sul-rs' },
  { city: 'Pelotas', state_abbr: 'RS', slug: 'pelotas-rs' },
  { city: 'Canoas', state_abbr: 'RS', slug: 'canoas-rs' },
  { city: 'Santa Maria', state_abbr: 'RS', slug: 'santa-maria-rs' },
];

export const MAIN_CITIES_RO: City[] = [
  { city: 'Porto Velho', state_abbr: 'RO', slug: 'porto-velho-ro' },
  { city: 'Ji-Paraná', state_abbr: 'RO', slug: 'ji-parana-ro' },
  { city: 'Ariquemes', state_abbr: 'RO', slug: 'ariquemes-ro' },
  { city: 'Vilhena', state_abbr: 'RO', slug: 'vilhena-ro' },
  { city: 'Cacoal', state_abbr: 'RO', slug: 'cacoal-ro' },
];

export const MAIN_CITIES_RR: City[] = [
  { city: 'Boa Vista', state_abbr: 'RR', slug: 'boa-vista-rr' },
  { city: 'Rorainópolis', state_abbr: 'RR', slug: 'rorainopolis-rr' },
  { city: 'Caracaraí', state_abbr: 'RR', slug: 'caracarai-rr' },
  { city: 'Alto Alegre', state_abbr: 'RR', slug: 'alto-alegre-rr' },
  { city: 'Mucajaí', state_abbr: 'RR', slug: 'mucajai-rr' },
];

export const MAIN_CITIES_SC: City[] = [
  { city: 'Florianópolis', state_abbr: 'SC', slug: 'florianopolis-sc' },
  { city: 'Joinville', state_abbr: 'SC', slug: 'joinville-sc' },
  { city: 'Blumenau', state_abbr: 'SC', slug: 'blumenau-sc' },
  { city: 'São José', state_abbr: 'SC', slug: 'sao-jose-sc' },
  { city: 'Criciúma', state_abbr: 'SC', slug: 'criciuma-sc' },
];

export const MAIN_CITIES_SP: City[] = [
  { city: 'São Paulo', state_abbr: 'SP', slug: 'sao-paulo-sp' },
  { city: 'Guarulhos', state_abbr: 'SP', slug: 'guarulhos-sp' },
  { city: 'Campinas', state_abbr: 'SP', slug: 'campinas-sp' },
  { city: 'São Bernardo do Campo', state_abbr: 'SP', slug: 'sao-bernardo-do-campo-sp' },
  { city: 'Santo André', state_abbr: 'SP', slug: 'santo-andre-sp' },
];

export const MAIN_CITIES_SE: City[] = [
  { city: 'Aracaju', state_abbr: 'SE', slug: 'aracaju-se' },
  { city: 'Nossa Senhora do Socorro', state_abbr: 'SE', slug: 'nossa-senhora-do-socorro-se' },
  { city: 'Lagarto', state_abbr: 'SE', slug: 'lagarto-se' },
  { city: 'Itabaiana', state_abbr: 'SE', slug: 'itabaiana-se' },
  { city: 'São Cristóvão', state_abbr: 'SE', slug: 'sao-cristovao-se' },
];

export const MAIN_CITIES_TO: City[] = [
  { city: 'Palmas', state_abbr: 'TO', slug: 'palmas-to' },
  { city: 'Araguaína', state_abbr: 'TO', slug: 'araguaina-to' },
  { city: 'Gurupi', state_abbr: 'TO', slug: 'gurupi-to' },
  { city: 'Porto Nacional', state_abbr: 'TO', slug: 'porto-nacional-to' },
  { city: 'Paraíso do Tocantins', state_abbr: 'TO', slug: 'paraiso-do-tocantins-to' },
];
